// import React, { useState } from "react";
// import { Helmet } from "react-helmet"; // Helmet import

import RandingStyle10 from "../../randing/RandingStyle10";

function Randing227({ urlCode, urlCodeSettingId }) {
  return (
    <>
      <RandingStyle10
        urlCode={urlCode}
        urlCodeSettingId={urlCodeSettingId}
        videoPath={`${process.env.REACT_APP_CDN_BASE}/images/218/01.mp4`}
        videoBottmIMG={`${process.env.REACT_APP_CDN_BASE}/images/227/2.gif`}
        qTitleColor="#660002"
        qOptionColor="blue"
        formFieldColor="white"
        postBTN={`${process.env.REACT_APP_CDN_BASE}/images/postBtns/red/applyButton2.png`}
        companyName="본원"
        // footerPath={`${process.env.REACT_APP_CDN_BASE}/images/footer/ggul.jpg`}
      />
    </>
  );
}
export default Randing227;
